import { render } from "./AssignList.vue?vue&type=template&id=598b4286&scoped=true&ts=true"
import script from "./AssignList.vue?vue&type=script&lang=ts"
export * from "./AssignList.vue?vue&type=script&lang=ts"

import "./AssignList.vue?vue&type=style&index=0&id=598b4286&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598b4286"]])

export default __exports__